import { Component, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { ObjectsService } from '@services/http/objects.service';
import { StateService } from '@services/state.service';
import { DevicesService } from '@services/http/devices.service';

/*Models*/
import { Device } from '@models/device';


/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';
declare var swal: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-device-phone-modal',
  templateUrl: './change-device-phone-modal.component.html'
})

export class ChangeDevicePhoneModalComponent {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('changeDevicePhoneModal') changeDevicePhoneModal: BsModalComponent;

  devicePhoneModel;

  errorMessage;
  currentDevice: Device;
  btnText: any = {
    text: 'Обновить',
    defaultText: 'Обновить',
    loadText: 'Обработка..'
  };
  trySend = false;

  constructor(
    private objectsService: ObjectsService,
    private stateService: StateService,
    private devicesService: DevicesService
  ) {
    this.currentDevice = this.stateService.currentDevice;

    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
      });
  }
  submit() {
    this.trySend = true;
    if (!this.devicePhoneModel) {
      return false;
    }
    this.btnText.text = this.btnText.loadText;


    this.devicesService.updatePhone(this.currentDevice.id, this.devicePhoneModel.replace(/\D/g, ''), this.currentDevice.phones[0].id)
      .subscribe(response => {
        this.trySend = false;
        this.close();
        this.stateService.updateDevicePhoneSubject.next(this.devicePhoneModel.replace(/\D/g, ''));
        swal({
          type: 'success',
          text: 'Номер телефона изменен',
          showConfirmButton: false,
          timer: 3000,
        });
      },
        error => {
          let errorMessage = 'Ошибка, повторите позже';
          if (error.error) {
            error = error.error;
          }
          if (error.errorMessage && error.errorMessage.length > 0) {
            errorMessage = error.errorMessage;
          }
          this.errorMessage = errorMessage;
          this.trySend = false;
          this.btnText.text = this.btnText.defaultText;
        }
      );
  }

  onChange(event) {
    this.devicePhoneModel = event;
  }

  open() {
    this.errorMessage = null;
    this.devicePhoneModel = undefined;
    this.changeDevicePhoneModal.open();
  }

  close() {
    this.changeDevicePhoneModal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/modal/change-device-phone/change-device-phone-modal.component.ts